var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"display"},_vm._l((_vm.colorDisplays),function(display,index){return _c('Color',{key:index,attrs:{"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }